import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GetSlackChannels } from 'domain/usecases';

import { RemoteGetSlackChannels } from 'data/usecases/slack';

export const makeGetSlackChannels = (): GetSlackChannels => {
  return new RemoteGetSlackChannels(makeApiUrl('/slack/channels'), makeAuthorizeHttpClientDecorator());
};
